
import { RepairType } from './constants';



const INIT_STATE = {
    repairRece: null,
    repairSend: null,
    updRepairRece: null,
    updSend: null,
    error: null,
    fault_response: null,
    devicetype_response: null,
    repairReturn: null,
    upd_repairReturn: null,
    repairHandover: null,
    upd_handover: null,
    repairstatus_response: null,
    loading: false,
    modal_Loading: false,
};


type RepairActionType = {
    type:
    | RepairType.API_RESPONSE_SUCCESS
    | RepairType.API_RESPONSE_ERROR
    | RepairType.REPAIR_RECE
    | RepairType.UPD_REPAIR_RECE
    | RepairType.REPAIR_SEND
    | RepairType.UPD_REPAIR_SEND
    | RepairType.REPAIR_RETURN
    | RepairType.UPD_REPAIR_RETURN
    | RepairType.REPAIR_HANDOVER
    | RepairType.UPD_REPAIR_HANDOVER
    | RepairType.RESET;
    payload: {
        actionType?: string;
        data?: any;
        error?: string;
    };
};

type State = {
    item?: any;
    loading?: boolean;
    value?: boolean;
};

const Repair = (state: State = INIT_STATE, action: RepairActionType): any => {
    switch (action.type) {
        case RepairType.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case RepairType.REPAIR_RECE: {
                    return {
                        ...state,
                        repairRece: action.payload,
                        loading: false,
                    };
                }

                case RepairType.UPD_REPAIR_RECE: {
                    return {
                        ...state,
                        updRepairRece: action.payload,
                        loading: false,
                    };
                }
                case RepairType.REPAIR_SEND: {
                    return {
                        ...state,
                        repairSend: action.payload,
                        loading: false,
                    };
                }

                case RepairType.UPD_REPAIR_SEND: {
                    return {
                        ...state,
                        updSend: action.payload,
                        loading: false,
                    };
                }
                
                case RepairType.REPAIR_RETURN: {
                    return {
                        ...state,
                        repairReturn: action.payload,
                        loading: false,
                    };
                }
                case RepairType.UPD_REPAIR_RETURN: {
                    return {
                        ...state,
                        upd_repairReturn: action.payload,
                        loading: false,
                    };
                }
                case RepairType.REPAIR_HANDOVER: {
                    return {
                        ...state,
                        repairHandover: action.payload,
                        loading: false,
                    };
                }
                case RepairType.UPD_REPAIR_HANDOVER: {
                    return {
                        ...state,
                        upd_handover: action.payload,
                        loading: false,
                    };
                }

                default:
                    return { ...state };
            }

        case RepairType.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {

                case RepairType.REPAIR_RECE: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        repairRece: null,
                        loading: false,
                    };
                }
                case RepairType.UPD_REPAIR_RECE: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        updRepairRece: null,
                        loading: false,
                    };
                }
                case RepairType.REPAIR_SEND: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        repairSend: null,
                        loading: false,
                    };
                }
                case RepairType.UPD_REPAIR_SEND: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        updSend: null,
                        loading: false,
                    };
                }
                case RepairType.REPAIR_RETURN: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        repairReturn: null,
                        loading: false,
                    };
                }
                case RepairType.UPD_REPAIR_RETURN: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        upd_repairReturn: null,
                        loading: false,
                    };
                }
                case RepairType.REPAIR_HANDOVER: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        repairHandover: null,
                        loading: false,
                    };
                }
                case RepairType.UPD_REPAIR_HANDOVER: {
                    return {
                        ...state,
                        registerError: action.payload.error,
                        upd_handover: null,
                        loading: false,
                    };
                }
                
                default:
                    return { ...state };
            }

        case RepairType.REPAIR_RECE:
            return { ...state, loading: true, repairRece: null };
        case RepairType.UPD_REPAIR_RECE:
            return { ...state, loading: true, updRepairRece: null };
        case RepairType.REPAIR_SEND:
            return { ...state, loading: true, repairSend: null };
        case RepairType.UPD_REPAIR_SEND:
            return { ...state, loading: true, updSend: null };
        case RepairType.REPAIR_RETURN:
            return { ...state, loading: true, repairReturn: null };
        case RepairType.UPD_REPAIR_RETURN:
            return { ...state, loading: true, upd_repairReturn: null };
        case RepairType.REPAIR_HANDOVER:
            return { ...state, loading: true, repairHandover: null };
        case RepairType.UPD_REPAIR_HANDOVER:
            return { ...state, loading: true, upd_handover: null };
        case RepairType.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                updRepairRece: null,
                updSend: null,
                repairSend: null,
                repairRece: null,
                fault_response: null,
                repairReturn: null,
                upd_repairReturn: null,
                repairHandover: null,
                upd_handover: null,
                devicetype_response: null,
            };
        default:
            return { ...state };
    }
};

export default Repair;
